import { Link } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";
import { useSeo } from "@/hooks/useSeo";

const scopes = [
  {
    icon: "ri-tv-2-line",
    title: "爱情电视剧",
    desc: "都市情感、青春校园、古装情缘与海外情感剧，收录作品基本信息、演职员与分集状态。",
  },
  {
    icon: "ri-film-line",
    title: "经典与热映电影",
    desc: "从黑白经典到近年热映，梳理每部爱情电影的故事梗概与看点，帮你快速做选择。",
  },
  {
    icon: "ri-file-text-line",
    title: "剧情介绍与看点",
    desc: "为每部作品撰写完整剧情简介与情感亮点，让你在观看前就能感受故事的浪漫脉络。",
  },
];

export default function AboutPage() {
  useSeo({
    title: "关于我们 - 恋爱的味道情感影视站",
    description:
      "恋爱的味道是专注情感类影视作品的内容站，分享爱情电视剧与电影资源信息、剧情介绍与观影视推荐，陪你在光影里感受浪漫。",
    keywords: "关于我们,恋爱的味道,情感影视站,爱情影视,剧情介绍",
  });

  return (
    <SiteLayout>
      <div className="mx-auto w-full max-w-[1280px] px-4 py-8 md:px-8">
        <nav className="flex flex-wrap items-center gap-1 text-sm text-foreground-600">
          <Link to="/" className="transition-colors hover:text-primary-600">
            首页
          </Link>
          <i className="ri-arrow-right-s-line"></i>
          <span className="text-foreground-900">关于我们</span>
        </nav>

        <section className="mt-6 overflow-hidden rounded-lg border border-background-200 bg-white">
          <div className="relative h-[220px] w-full md:h-[300px]">
            <img
              src="https://readdy.ai/api/search-image?query=Warm%20romantic%20artistic%20banner%20with%20soft%20pink%20silk%20curtains%20and%20gentle%20golden%20light%2C%20dreamy%20minimal%20composition%2C%20no%20text%2C%20cohesive%20pastel%20rose%20and%20cream%20palette%2C%20high%20detail&width=1600&height=500&seq=love-about-01&orientation=landscape"
              alt="恋爱的味道品牌氛围图"
              title="恋爱的味道 - 情感影视内容站"
              className="h-full w-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/60 to-foreground-950/20"></div>
            <div className="absolute inset-0 flex flex-col justify-center px-6 md:px-12">
              <h1 className="font-heading text-2xl font-bold text-white md:text-4xl">关于恋爱的味道</h1>
              <p className="mt-3 max-w-xl text-sm leading-relaxed text-white/85 md:text-base">
                专注情感类影视作品的资源分享与剧情介绍，陪你在爱情的光影里，慢慢找到想看的那一部。
              </p>
            </div>
          </div>

          <div className="p-6 md:p-10">
            <h2 className="font-heading text-xl font-bold text-foreground-950">网站定位</h2>
            <p className="mt-4 max-w-4xl text-sm leading-7 text-foreground-700">
              「恋爱的味道」是一个面向情感影视爱好者的内容分享站。我们希望用清晰的分类、真实的剧情介绍和
              用心的推荐，帮助喜爱爱情、浪漫与情感题材的用户，快速找到心仪的电视剧与电影。
              本站所有影视作品信息、评分与热度均为演示内容，用于呈现网站的浏览与筛选体验。
            </p>

            <h2 className="mt-10 font-heading text-xl font-bold text-foreground-950">内容范围</h2>
            <div className="mt-5 grid grid-cols-1 gap-4 md:grid-cols-3">
              {scopes.map((item) => (
                <div key={item.title} className="rounded-lg border border-background-200 bg-background-50 p-5">
                  <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-100 text-primary-600">
                    <i className={`${item.icon} text-xl`}></i>
                  </span>
                  <h3 className="mt-3 font-heading text-base font-bold text-foreground-950">{item.title}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
                </div>
              ))}
            </div>

            <h2 className="mt-10 font-heading text-xl font-bold text-foreground-950">使用与声明</h2>
            <ul className="mt-4 space-y-3">
              {[
                "本站内容以剧情介绍与作品信息分享为主，不提供任何影视资源的在线播放与下载。",
                "作品评分、浏览量等数据为演示样例，仅用于展示页面的筛选与推荐效果。",
                "若您对收录内容有任何建议，欢迎通过下方邮箱与我们联系，我们会认真对待每一条反馈。",
              ].map((item) => (
                <li key={item} className="flex items-start gap-3 text-sm leading-relaxed text-foreground-700">
                  <i className="ri-checkbox-circle-fill mt-0.5 text-base text-primary-500"></i>
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </section>

        <section className="mt-8 grid grid-cols-1 gap-4 md:grid-cols-2">
          <div className="rounded-lg border border-background-200 bg-white p-6">
            <h2 className="font-heading text-lg font-bold text-foreground-950">联系我们</h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              内容合作、意见反馈或建议，都欢迎随时来信，我们会尽快回复。
            </p>
            <div className="mt-5 space-y-3 text-sm">
              <p className="flex items-center gap-2 text-foreground-800">
                <i className="ri-mail-send-line text-primary-500"></i>
                hello@lianaideweidao.com
              </p>
              <p className="flex items-center gap-2 text-foreground-800">
                <i className="ri-customer-service-2-line text-primary-500"></i>
                意见反馈：feedback@lianaideweidao.com
              </p>
              <p className="flex items-center gap-2 text-foreground-800">
                <i className="ri-time-line text-primary-500"></i>
                服务时间：每日 09:00 - 22:00
              </p>
            </div>
          </div>

          <div className="rounded-lg border border-background-200 bg-white p-6">
            <h2 className="font-heading text-lg font-bold text-foreground-950">快速导航</h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              从这里开始，探索更多温暖浪漫的影视作品。
            </p>
            <div className="mt-5 grid grid-cols-2 gap-3">
              <Link
                to="/category/电视剧"
                className="flex items-center gap-2 rounded-md border border-background-200 bg-background-50 px-4 py-3 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-600"
              >
                <i className="ri-tv-2-line"></i> 电视剧
              </Link>
              <Link
                to="/category/电影"
                className="flex items-center gap-2 rounded-md border border-background-200 bg-background-50 px-4 py-3 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-600"
              >
                <i className="ri-film-line"></i> 电影
              </Link>
              <Link
                to="/search"
                className="flex items-center gap-2 rounded-md border border-background-200 bg-background-50 px-4 py-3 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-600"
              >
                <i className="ri-search-line"></i> 搜索
              </Link>
              <Link
                to="/"
                className="flex items-center gap-2 rounded-md border border-background-200 bg-background-50 px-4 py-3 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-600"
              >
                <i className="ri-home-4-line"></i> 首页
              </Link>
            </div>
          </div>
        </section>
      </div>
    </SiteLayout>
  );
}